// extracted by mini-css-extract-plugin
export default {"layout_default":"default-layout_layout_default__mh0AP"};